/***
 * Created on 2023/9/7
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import {useBoundedStore} from '../lib/store';
import {useEffect} from "react";
import {setLocalLanguage} from "../service/common";
import {useTranslation} from "react-i18next";

export const useLanguage = () => {
    const { i18n } = useTranslation();
    const store = useBoundedStore();

    useEffect(() => {
        if (i18n.language !== store.language) {
            setLocalLanguage(store.language);
            i18n.changeLanguage(store.language);
        }
    }, [store.language]);
};